import type { OriginName } from '~/interfaces/common';
import { fetchJson } from '~/utils/fetch-json';

import type {
  AuthenticationResponse,
  CheckAliasesAvailabilityResponse,
} from '../-types/types';

export const checkAliasesAvailability = async (alias: string) => {
  const res = await fetchJson<
    CheckAliasesAvailabilityResponse | { message: string }
  >(`/aliases?alias=${alias}`, {}, true);

  return res;
};

export const initiateAuthentication = (
  originName: OriginName,
  alias: string,
) => {
  const res = fetchJson<AuthenticationResponse>(
    `/origins/${originName}/assert?alias=${alias}`,
  );

  return res;
};
